<template>
  <v-container>
    <!-- <TitleH1 text="Categorias" /> -->
    <Subtitulo v-if="ojbPedidos && ojbPedidos.listadepedidos && ojbPedidos.listadepedidos.length > 0" :subtitulo="ojbPedidos.statuscomanda === 'Pedido Baixado'?'Pedido Entregue':ojbPedidos.statuscomanda" :corTexto="corTexto" />
    <Subtitulo v-if="ojbPedidos && ojbPedidos.listadepedidos && ojbPedidos.listadepedidos.length > 0" :subtitulo="'Total: R$ '+ojbPedidos.valorTotal.toFixed(2)" :corTexto="corTexto" />
    <v-row class="ma-0 mt-2 mb-5">
      <v-col cols="12" v-for="pedido in ojbPedidos.listadepedidos" :key="pedido.numpedido" class="pa-1">
        <Pedido
          :pedido="pedido" :corTexto="corTexto"
          @retirarPedido="(produto)=>retirarPedido(produto)"
         />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // import TitleH1 from './TitleH1.vue'
  import Subtitulo from '../../components/layout/Subtitulo.vue'
  import Pedido from './Pedido.vue'
  export default {
    name: 'PedidosLista',
    props:['ojbPedidos','statuscomanda','corTexto'],
    components:{
      // TitleH1,
      Pedido,
      Subtitulo,
    },
    data: () => ({
      // listadeprodutos:[]
    }),

    methods:{

      retirarPedido(produto){
        this.$emit('retirarPedido',produto)
      }

    },

    mounted(){
      // this.getProdutos()
    }



  }
</script>

<style scoped>
    .categoryList{
      /* background-color:green; */
      display:flex;
      flex-wrap: wrap;
      justify-content: center;
      width:100%;
      padding:0px!important;
    }
</style>
